// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CertificationsRouteImport } from './routes/certifications'
import { Route as ExamsRouteImport } from './routes/exams'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as TestingEventsRouteImport } from './routes/testing-events'
import { Route as redirectsSplatRouteImport } from './routes/(redirects)/$'
import { Route as redirectsAboutusRouteImport } from './routes/(redirects)/aboutus'
import { Route as redirectsContactRouteImport } from './routes/(redirects)/contact'
import { Route as redirectsExamprepRouteImport } from './routes/(redirects)/examprep'
import { Route as redirectsFaqRouteImport } from './routes/(redirects)/faq'
import { Route as redirectsLinksRouteImport } from './routes/(redirects)/links'
import { Route as redirectsTestsitesRouteImport } from './routes/(redirects)/testsites'
import { Route as redirectsTracksRouteImport } from './routes/(redirects)/tracks'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CertificationsRoute = CertificationsRouteImport.update({
            id: '/certifications',path: '/certifications',getParentRoute: () => rootRouteImport
          })
const ExamsRoute = ExamsRouteImport.update({
            id: '/exams',path: '/exams',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const TestingEventsRoute = TestingEventsRouteImport.update({
            id: '/testing-events',path: '/testing-events',getParentRoute: () => rootRouteImport
          })
const redirectsSplatRoute = redirectsSplatRouteImport.update({
            id: '/(redirects)/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const redirectsAboutusRoute = redirectsAboutusRouteImport.update({
            id: '/(redirects)/aboutus',path: '/aboutus',getParentRoute: () => rootRouteImport
          })
const redirectsContactRoute = redirectsContactRouteImport.update({
            id: '/(redirects)/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const redirectsExamprepRoute = redirectsExamprepRouteImport.update({
            id: '/(redirects)/examprep',path: '/examprep',getParentRoute: () => rootRouteImport
          })
const redirectsFaqRoute = redirectsFaqRouteImport.update({
            id: '/(redirects)/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const redirectsLinksRoute = redirectsLinksRouteImport.update({
            id: '/(redirects)/links',path: '/links',getParentRoute: () => rootRouteImport
          })
const redirectsTestsitesRoute = redirectsTestsitesRouteImport.update({
            id: '/(redirects)/testsites',path: '/testsites',getParentRoute: () => rootRouteImport
          })
const redirectsTracksRoute = redirectsTracksRouteImport.update({
            id: '/(redirects)/tracks',path: '/tracks',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CertificationsRoute: CertificationsRoute,ExamsRoute: ExamsRoute,FaqsRoute: FaqsRoute,ResourcesRoute: ResourcesRoute,TestingEventsRoute: TestingEventsRoute,redirectsSplatRoute: redirectsSplatRoute,redirectsAboutusRoute: redirectsAboutusRoute,redirectsContactRoute: redirectsContactRoute,redirectsExamprepRoute: redirectsExamprepRoute,redirectsFaqRoute: redirectsFaqRoute,redirectsLinksRoute: redirectsLinksRoute,redirectsTestsitesRoute: redirectsTestsitesRoute,redirectsTracksRoute: redirectsTracksRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)